import { render, staticRenderFns } from "./EditFolder.vue?vue&type=template&id=a1921e9c&scoped=true"
import script from "./EditFolder.vue?vue&type=script&lang=js"
export * from "./EditFolder.vue?vue&type=script&lang=js"
import style0 from "./EditFolder.vue?vue&type=style&index=0&id=a1921e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1921e9c",
  null
  
)

export default component.exports